import ComponentManager from "../../componentFramework";
import EventListenerManager from "../EventListenerManager";
import EditContentNode from "../EditContentNode";
import JsfJsCommand from "../JsfJsCommand";
import EventManager from "../EventManager";

export interface ComponentStaticEventMap {
	"focusChange": {nodeId: number | null}; // null mean this (aka the "page" or root)
}

/**
 */
@ComponentManager.register({requires: () => EditContentNode})
export default class EditContentNodes {
	public static componentStyleClass = "editContentNodes";

	private static readonly eventManager = new EventManager<ComponentStaticEventMap>();
	public static readonly addEventListener = EditContentNodes.eventManager.addEventListener;
	public static readonly removeEventListener = EditContentNodes.eventManager.removeEventListener;

	private readonly eventListenerManager = new EventListenerManager();

	constructor(public readonly rootElement: HTMLElement) {
		this.eventListenerManager.manage(rootElement).addEventListener("click", (event: MouseEvent) => {
			this.focusPage()
			event.stopPropagation();
		});
	}

	@ComponentManager.on("removed")
	protected componentRemoved() {
		this.eventListenerManager.removeListeners();
	}

	public static notifyFocusChange(nodeId: number | null) {
		EditContentNodes.eventManager.notifyEventListeners(
			"focusChange",
			{nodeId: nodeId}
		);
	}

	public focusPage() {
		const focusCommand = ComponentManager.queryForComponent(
			this.rootElement,
			JsfJsCommand,
			".editContentNodes__focusAction"
		);
		if (focusCommand !== undefined) {
			focusCommand.run();
			EditContentNodes.notifyFocusChange(null);
		}
	}
}
